module.exports = __webpack_public_path__ + "static/media/competition_ccc.9823bac8.png";